import { useState } from 'react';

const isTd = (stat) => stat === 'anytime_td' || stat === 'passing_tds' || stat === 'threes';

// Same model as the backend: Poisson for TDs, normal (continuity-corrected) for yards.
export const probAtLeast = (stat, mean, sd, mark) => {
  if (isTd(stat)) {
    const lam = Math.max(mean, 0.01);
    let cdf = 0; let f = 1;
    for (let k = 0; k < mark; k += 1) { if (k > 0) f *= k; cdf += Math.exp(-lam) * lam ** k / f; }
    return 1 - cdf;
  }
  const z = (mark - 0.5 - mean) / Math.max(sd || mean * 0.3, 1);
  return 0.5 * (1 + erf(-z / Math.SQRT2));
};

function erf(x) {
  const t = 1 / (1 + 0.3275911 * Math.abs(x));
  const y = 1 - (((((1.061405429 * t - 1.453152027) * t) + 1.421413741) * t - 0.284496736) * t + 0.254829592) * t * Math.exp(-x * x);
  return x >= 0 ? y : -y;
}

// Type the line from your sportsbook (e.g. 249.5) and see the model's over/under chance.
export default function LineCheck({ pr, testId }) {
  const [line, setLine] = useState('');
  const n = parseFloat(line);
  const mark = Number.isFinite(n) ? Math.floor(n) + 1 : null;
  const over = mark != null ? probAtLeast(pr.stat, pr.projection, pr.sd, mark) : null;
  const pctTxt = (p) => `${Math.round(p * 100)}%`;
  const verdict = over == null ? null : over >= 0.65 ? ['Lean OVER', 'text-emerald-300'] : over <= 0.35 ? ['Lean UNDER', 'text-rose-300'] : ['Too close', 'text-zinc-400'];
  return (
    <div className="mt-1.5 flex flex-wrap items-center gap-2" data-testid={testId}>
      <input value={line} onChange={(e) => setLine(e.target.value)} inputMode="decimal" placeholder={isTd(pr.stat) ? 'Your line e.g. 1.5' : 'Your book line e.g. 24.5'}
        className="w-36 rounded-md border border-zinc-700 bg-zinc-950 px-2 py-1 text-[11px] text-white" data-testid={`${testId}-input`} />
      {over != null && (
        <span className="text-[11px] text-zinc-300" data-testid={`${testId}-result`}>
          Over {n}: <b className="text-white">{pctTxt(over)}</b> · Under: <b className="text-white">{pctTxt(1 - over)}</b>
          <span className={`ml-1.5 font-bold ${verdict[1]}`}>{verdict[0]}</span>
        </span>
      )}
    </div>
  );
}
